module.exports = __webpack_public_path__ + "img/61_14.52750c8b.png";